// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customize Swiper navigation arrows */
.swiper-button-next,
.swiper-button-prev {
  color: rgba(0, 0, 0, 0.7); /* Light black color */
  padding: 10px; /* Optional: Add padding for better look */
  border-radius: 50%; /* Make it circular */
  transition: background-color 0.3s, transform 0.2s; /* Add hover effects */
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  color: white; /* White arrow color on hover */
  transform: scale(1.1); /* Slight zoom effect */
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/swiper.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;;EAEE,yBAAyB,EAAE,sBAAsB;EACjD,aAAa,EAAE,0CAA0C;EACzD,kBAAkB,EAAE,qBAAqB;EACzC,iDAAiD,EAAE,sBAAsB;AAC3E;;AAEA;;EAEE,YAAY,EAAE,+BAA+B;EAC7C,qBAAqB,EAAE,uBAAuB;AAChD","sourcesContent":["/* Customize Swiper navigation arrows */\n.swiper-button-next,\n.swiper-button-prev {\n  color: rgba(0, 0, 0, 0.7); /* Light black color */\n  padding: 10px; /* Optional: Add padding for better look */\n  border-radius: 50%; /* Make it circular */\n  transition: background-color 0.3s, transform 0.2s; /* Add hover effects */\n}\n\n.swiper-button-next:hover,\n.swiper-button-prev:hover {\n  color: white; /* White arrow color on hover */\n  transform: scale(1.1); /* Slight zoom effect */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
